<template>
    <section class="modal account">
        <div class="bg" @click="window.toggleAccount()"></div>
        <div class="panel-scroller">
            <div class="panel">
                <a href="#" class="close" onclick="return toggleAccount();"></a>
                <form @submit.prevent class="form">
                    <div class="modal-head">
                        <h2 class="h2">Sounds</h2>
                        <h3 class="h2 black">{{ window.t('sounds_login') }}</h3>
                    </div>
                    <div class="modal-body">
                        <!--LOGIN PAGE-->
                        <div class="row">
                            <div class="col c6">
                                <h3 class="h5 black mb1">{{ window.t('sounds_login_info_title') }}</h3>
                                <div v-html="window.t('sounds_login_info')" class="txt">
                                </div>
                            </div>
                            <div class="col c5 o1" v-if="visibleType == 'auth'">
                                <h3 class="h5 black mb1">{{ window.t('sounds_login') }}</h3>
                                <div class="fields">
                                    <div class="field w100">
                                        <input type="email" :placeholder="window.t('form_your_email')" required v-model="form.email" @keyup.enter="login">
                                        <span class="incorrect" v-if="error('email')" v-html="error('email')"></span>
                                    </div>
                                    <div class="field w100">
                                        <input type="password" :placeholder="window.t('form_password')" required v-model="form.password" @keyup.enter="login">
                                        <span class="incorrect" v-if="error('password')" v-html="error('password')"></span>
                                    </div>
                                </div>
                                <br>
                                <a href="#" @click.prevent="toggleVisible('forgotpassword')" class="hover-underline">{{ window.t('sounds_password_forgot') }}</a>
                            </div>
                            <div class="col c5 o1" v-if="visibleType == 'forgotpassword'">
                                <a href="#" @click.prevent="toggleVisible('auth')" class="hover-underline">&lt; {{ window.t('sounds_back_to_login') }}</a>
                                <br>
                                <br>
                                <br>
                                <h3 class="h5 black mb1">{{ window.t('sounds_reset_your_pw') }}</h3>
                                <div v-if="resetPasswordSent">
                                    {{ window.t('sounds_password_reset_sent') }}
                                </div>
                                <div class="fields" v-else>
                                    <div class="field w100">
                                        <input type="email" placeholder="E-mail" required v-model="form.email" @keyup.enter.prevent="resetPassword">
                                        <span class="incorrect" v-if="error('email')" v-html="error('email')"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="col c5 o1" v-if="visibleType == 'resetpassword'">
                                <!-- <a href="#" @click.prevent="toggleVisible('auth')" class="hover-underline">&lt; {{ window.t('sounds_back_to_login') }}</a> -->
                                <br>
                                <br>
                                <br>
                                <h3 class="h5 black mb1">{{ window.t('sounds_reset_your_pw') }}</h3>
                                <div class="fields">
                                    <div class="field w100">
                                        <input type="email" placeholder="E-mail" required v-model="resetPasswordForm.email">
                                        <span class="incorrect" v-if="error('email')" v-html="error('email')"></span>
                                    </div>
                                    <div class="field w100">
                                        <input type="password" placeholder="Password" required v-model="resetPasswordForm.password">
                                        <span class="incorrect" v-if="error('password')" v-html="error('password')"></span>
                                    </div>
                                    <div class="field w100">
                                        <input type="password" placeholder="Confirm password" required v-model="resetPasswordForm.password_confirmation">
                                        <span class="incorrect" v-if="error('password_confirmation')" v-html="error('password_confirmation')"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-foot">
                        <a :href="registerUrl" class="btn w180">{{ window.t('sounds_register_btn') }}</a>
                        <a href="#" class="btn w180 push-to-end" @click.prevent="login" v-if="visibleType == 'auth'">{{ window.t('sounds_login') }}</a>
                        <a href="#" class="btn w180 push-to-end" @click.prevent="resetPassword" v-if="visibleType == 'forgotpassword' && !resetPasswordSent">{{ window.t('sounds_password_reset') }}</a>
                        <a href="#" class="btn w180 push-to-end" @click.prevent="submitResetPassword" v-if="visibleType == 'resetpassword'">{{ window.t('sounds_password_reset') }}</a>
                    </div>
                </form>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        props: {
            url: {
                type: String,
                default: '/',
            },
            registerUrl: {
                type: String,
                default: '/register',
            },
        },
        data() {
            return {
                window,
                isSubmitting: false,
                errors: {},
                open: false,
                form: {
                    email: '',
                    password: '',
                    redirect: '/',
                },
                visibleType: 'auth',
                resetPasswordSent: false,

                resetPasswordForm: {
                    token: '',
                    email: '',
                    password: '',
                    password_confirmation: '',
                }
            };
        },
        methods: {
            login() {
                if (this.isSubmitting) {
                    return false;
                }
                this.errors = {};
                this.isSubmitting = true;

                var headers = {
                    'Content-Type': 'application/json'
                };

                axios.post('/login', this.form, {headers})
                    .then(response => {
                        if(response.data.redirect) {
                            window.location.href = response.data.redirect;
                        }
                    })
                    .catch(error => {
                        if(error.response.data.errors) {
                            this.errors = error.response.data.errors;
                        }
                    })
                    .finally(() => this.isSubmitting = false);
            },
            resetPassword() {
                if (this.isSubmitting) {
                    return false;
                }
                this.errors = {};
                this.isSubmitting = true;

                var headers = {
                    'Content-Type': 'application/json'
                };

                axios.post('/password/email', this.form, {headers})
                    .then(response => {
                        if (response.data.success) {
                            this.resetPasswordSent = true;
                        } else {
                            this.errors = {
                                email: [response.data.error]
                            }
                        }
                    })
                    .catch(error => {
                        if(error.response.data.errors) {
                            this.errors = error.response.data.errors;
                        }
                    })
                    .finally(() => this.isSubmitting = false);
            },
            submitResetPassword() {
                if (this.isSubmitting) {
                    return false;
                }
                this.errors = {};
                this.isSubmitting = true;

                const headers = {
                    'Content-Type': 'application/json',
                };

                axios.post('/password/reset', this.resetPasswordForm, { headers })
                    .then(response => {
                        if (response.data.status == 'passwords.reset') {
                            const newLocation = location.href.replace(location.search, '');

                            if (location.href != newLocation) {
                                location = newLocation;
                            } else {
                                location.reload();
                            }
                        }
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            this.errors = error.response.data.errors;
                        }
                    })
                    .finally(() => this.isSubmitting = false);
            },
            error(fieldName) {
                return (this.errors[fieldName] || []).join('<br>');
            },
            toggleVisible(visible) {
                this.errors = {};
                this.visibleType = visible;
            }
        },
        mounted: async function() {
            this.form.redirect = this.url;


            const $_GET = {}

            window.location.search.substring(1)
                .split('&')
                .map(keyValue => keyValue.split('='))
                .forEach(keyValue => $_GET[keyValue[0]] = keyValue[1]);

            if ($_GET.hasOwnProperty('password-reset-token')) {
                const token = decodeURIComponent($_GET['password-reset-token']);

                this.resetPasswordForm.token = token;
                this.resetPasswordForm.email = $_GET.email ? decodeURIComponent($_GET.email) : '';

                toggleAccount();
                this.toggleVisible('resetpassword');
            }
        },
    }
</script>
